import React from "react";
import { Button } from "@/components/ui/button";

type ChatMode = 'chat' | 'debug' | 'recommend';

interface QuickPromptsProps {
  mode: ChatMode;
  onPromptClick: (prompt: string) => void;
  compact?: boolean;
}

const quickPrompts = {
  chat: [
    "Explain React hooks",
    "What are SQL joins?",
    "How does async/await work?",
    "Explain REST APIs"
  ],
  debug: [
    "Help me fix a TypeError",
    "Why is my API call failing?",
    "Debug infinite loop",
    "Fix CORS error"
  ],
  recommend: [
    "What should I learn next?",
    "Recommend a JavaScript course",
    "Best practices for React",
    "Advanced SQL topics"
  ]
};

const QuickPrompts: React.FC<QuickPromptsProps> = ({ mode, onPromptClick, compact = false }) => {
  const prompts = quickPrompts[mode];

  return (
    <div className={`flex flex-wrap gap-2 ${compact ? '' : 'justify-center'}`}>
      {prompts.map((prompt, index) => (
        <Button
          key={index}
          variant="outline"
          size={compact ? "sm" : "default"}
          onClick={() => onPromptClick(prompt)}
          className={compact ? "text-xs" : ""}
        >
          {prompt}
        </Button>
      ))}
    </div>
  );
};

export default QuickPrompts;
